// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input, Col,
  Row, 
  Table,FormGroup} from "reactstrap";

import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import ReactModal from 'react-modal';
import api from "../../../apis/api";
import Calendar from "react-calendar";
import { red } from "@material-ui/core/colors";
import "../../../style/processleave.css";
import { set } from "react-ga";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ViewProcessDuty = React.memo(
  ({
    leaverequestDetails,
    myleavedetailedlist,
    myappliedleavelist,
    handlerecholidayCalendarArray,
    handleleavestatus,
    empTask,
    handleSelectedTask,
    handleDelTask,
    dateArray,
    toggleview
  }) => {
    const [thead] = useState([
      "Name",
      "Type",
      "Applied",
      "DateFrom",
      "DateTo",
      "Days",
      "Status",
      "Action",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);
    const [isOpen, setIsOpen] = useState(false);
   
    // const [dateArray,setDateArray]=useState([]);
    const [comment,setcomment]=useState("");
    const [calenderDate] = useState(new Date());
    const [action ,setaction] =useState("");
    const [approve,setapprove] =useState(false);
    const [reject,setreject] = useState(false);
    // const [comment,setcomment] =useState("")
    const buttonStyles = {
      position: "absolute",
      top: "10px",
      right: "10px"
    };
    let holidaylist=[];
    handlerecholidayCalendarArray != undefined ? handlerecholidayCalendarArray.map(function (hol){
    holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
  }) :holidaylist.push([]);

  let leavestatuslist=[];
  handleleavestatus != undefined ? handleleavestatus.map(function (hol){
    leavestatuslist.push({value :hol.leaveStatusId,label :hol.status});
}): leavestatuslist.push([]);
    useEffect(() => {
      setleavelist(empTask);

    },[empTask])
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

  //  const handledelAppliedleave =React.useCallback((leave) =>{
  //   delAppliedLeaves(leave);
  //  },[delAppliedLeaves])

  const handleSaveForm =React.useCallback((leaverequestId) =>{
    if(action !="")
    {
      const fetchApi = async () => {
        let arr=[];
     
       const res= await api
        .dbCalendarYear()
        .ApproveLeaveRequest(parseInt(leaverequestId),parseInt(action),comment);
      }
      const fetchApirej = async () => {
        let arr=[];
     
       const res= await api
        .dbCalendarYear()
        .RejectLeaveRequest(parseInt(leaverequestId),parseInt(action),comment);
      }
      if(approve==true)
      {
        fetchApi();
      }
      else
      {
        fetchApirej();
      }
      
    }
    
  else
  {
    alert("Please select Approve/Reject action");
  }
     },[approve,reject])

const handlesetaction =React.useCallback((val,id) =>{

if(id===1)
{
setapprove(true);
setreject(false);
setaction(val);
}
else
{
setaction(val);
setapprove(false);
setreject(true);
}
},[setapprove,setreject,setaction]);


    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);
  
  //   const getDates = (myappliedleavelist) => {
  //     const dates = [];
  //     myappliedleavelist.forEach(element => {
  //       if (element.fromDate && element.toDate) {
  //         const start = new Date(element.fromDate);
  //         const end = new Date(element.toDate);
  //         const days = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
  //         for (let i = 0; i <= days; i++) {
  //             const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
  //             dates.push(moment(currentDate).format("DD-MM-YYYY"));
  //         }
        
  //     }
  //     });
  //     setDateArray(dates);
  // };
    
    return (
      <div className="divstyle">
      <Fragment>

          

        
        <Row>
      <Col>
        <h3>Duty Request Details</h3>
      </Col>
      <Col>
        
     
        </Col>
      </Row>

          <Row>
            <Col>
            <Label>Name : </Label>
            <Label>{leaverequestDetails.length>0? leaverequestDetails[0].employeeName : null}</Label>
            </Col>
            <Col>
            <Label>Department : </Label>
            <Label>{leaverequestDetails.length>0? leaverequestDetails[0].departmentName :null}</Label>
            </Col>
            <Col>
            <Label>Designation : </Label>
            <Label>{leaverequestDetails.length>0?leaverequestDetails[0].designationName : null}</Label>
            </Col>
          </Row>
         
          <br/>
          <Row>
            <Col md={12}>
            {myappliedleavelist.length >0 ? (<Table>
            <tr>
              <th>Applied</th>
                    <th>Date From</th>
                    <th>Date To</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th>Day(s)</th>
                </tr>
                {myappliedleavelist.map((val, key) => {
                    return (
                        <tr key={key}>
                            <td>{moment(val.createdDate).format("DD-MM-YYYY")}</td>
                            <td>{moment(val.fromDate).format("DD-MM-YYYY")}</td>
                            <td>{moment(val.toDate).format("DD-MM-YYYY")}</td>
                            <td>{val.type}</td>
                            <td>{val.reason}</td>
                            <td>{val.noOfDays}</td>

                        </tr>
                    )
                })}
            </Table>) :null}  
            </Col>
          
          </Row>
          <br/>
          <Row>
            <Col md={6}>
            <Table>
              <tr>
                
                <th>Contact Details</th>
                 <th>Approver</th>
                <th>Status</th>
              </tr>
              <tr>
                
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].contactDetails : null}</td>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].approver : null}</td>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].dutyStatus : null}</td>
              </tr>
            </Table>
            </Col>
          </Row>
          <br/>
          
          <Row>
            <Col md={6}>
            
            </Col>
            <Col md={2}>
              
            </Col>
            <Col md={4} className=" newstyle">
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Label style={{ marginBottom: 0 }}>Holiday</Label>
                <Button className="btn btn-secondary" style={{ background: "red", border: "none", width: "20px", height: "20px", padding: 0 }} />
              </div>
            
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Label style={{ marginBottom: 0 }}>Duty(s)Applied</Label>
                <Button className="btn btn-secondary" style={{ background: "green", border: "none", width: "20px", height: "20px", padding: 0 }} />
              </div>
            </div>
            <br/>
            <Calendar
              // onChange={(date) => props.handleOnchangeDate(date)}
              
              value={calenderDate}
               tileClassName={({ date, view }) => {
                              if(holidaylist.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                               return  'highlight'
                              }
                              else if(dateArray.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                                return  'leavehighlight'
                               }
                            }}
          
              disabledKeyboardNavigation
            />
            </Col>
          </Row>
          <Row className="detailslist">
            <Col md={3}></Col>
            <Col md={3}> &nbsp; <Button color="" className="btn-cancel" onClick={toggleview}>
              Cancel
            </Button></Col>
            <Col md={3} >
           
            </Col>
            <Col md={3}></Col>
          </Row>
         
          </Fragment>
      </div>
    );
  }
);

export default ViewProcessDuty;
